import { useMemo } from "react";
import { useSelector } from "react-redux";
import { TRootState } from "../../store";
import { PARTNER, Role_type, ROLE_TYPE } from "../../constants/partners";

export const useUIPermissions = () => {
  const { loginType, roleType, finPartnerId } = useSelector(
    (state: TRootState) => ({
      loginType: state.auth.userInfo?.type,
      roleType: state.auth.userInfo?.roleType as Role_type,
      finPartnerId: state.auth.userInfo?.finPartnerId,
    }),
  );

  return useMemo(() => {
    const isInternalUser = loginType === PARTNER.ONO || finPartnerId === 0;
    const isPartnerUser = !isInternalUser;

    return {
      isInternalUser,
      isPartnerUser,

      hasAdminManagerEditAccess:
        roleType === ROLE_TYPE.ADMIN ||
        roleType === ROLE_TYPE.FINANCE_MANAGER ||
        roleType === ROLE_TYPE.RISK_MANAGER,

      hasAdminAccess: roleType === ROLE_TYPE.ADMIN,

      hasAdminFinManagerAccess:
        roleType === ROLE_TYPE.ADMIN || roleType === ROLE_TYPE.FINANCE_MANAGER,

      hasRiskManagerAccess: roleType === ROLE_TYPE.RISK_MANAGER,

      hasReadOnlyAccess: roleType === ROLE_TYPE.READ_ONLY,
    };
  }, [loginType, roleType]);
};
